import React, { useRef, useState, useEffect } from 'react'

import AceEditor from 'react-ace'
import { ReplyIcon, DownloadIcon, PlayIcon, PencilIcon, ScreenFullIcon, ScreenNormalIcon } from '@primer/octicons-react'

import downloadFile from 'js-file-download'

import "ace-builds/src-noconflict/mode-jsx";
import "ace-builds/src-min-noconflict/ext-searchbox";
import "ace-builds/src-min-noconflict/ext-language_tools";

require('ace-builds/src-noconflict/mode-python')
require('ace-builds/src-noconflict/snippets/python')
require(`ace-builds/src-noconflict/theme-monokai`)

export default function CodeEditor(props) {
	const [isInFullscreen, setIsInFullScreen] = useState(false);

	const aceEditorRef = useRef();

	const [canUndo, setCanUndo] = useState();
	const [canRedo, setCanRedo] = useState();

	const updateHistory = () => {
		setCanUndo(aceEditorRef.current.editor.session.getUndoManager().canUndo());
		setCanRedo(aceEditorRef.current.editor.session.getUndoManager().canRedo());
	}

	const undo = () => {
		if (!canUndo) {
			return;
		}

		aceEditorRef.current.editor.undo();
		updateHistory();
	}

	const redo = () => {
		if (!canRedo) {
			return;
		}

		aceEditorRef.current.editor.redo();
		updateHistory();
	}

	const download = () => {
		const code = aceEditorRef.current.props.value;

		console.log(code);

		if (code === null) {
			console.log(`Unable to create python script file because code was null or not accessible`);
			return;
		}

		downloadFile(code, 'script.py');
	}

	const onCodeChange = (code) => {
		updateHistory();

		if (props.onChange !== undefined) {
			props.onChange(code);
		}
	}

	useEffect(() => {
		updateHistory();

	}, [])

	return (
		<>
			<div className="code-editor" style={isInFullscreen ? { position: "fixed", width: "100%", height: "100%", left: 0, top: 0, zIndex: 900 } : null}>
				<div className="code-editor-actions">
					<div className="position-relative">
						<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/768px-Python-logo-notext.svg.png" alt="Code language logo" />
					</div>
					<ul className="code-editor-menu">
						<li className="code-editor-action">
							<span><PencilIcon />Bearbeiten</span>
							<ul>
								<li onClick={() => {
									if (aceEditorRef.current.editor?.searchBox?.active) {
										aceEditorRef.current.editor.searchBox.findAll();
									} else {
										const e = require("ace-builds/src-noconflict/ext-searchbox");
										e.Search(aceEditorRef.current.editor, false);
									}
								}}>
									<span>Suchen</span>
									<div>
										<kbd>CTRL</kbd>+
										<kbd>F</kbd>
									</div>
								</li>
								<li onClick={() => {
									if (aceEditorRef.current.editor?.searchBox?.active) {
										aceEditorRef.current.editor.searchBox.replace();
									} else {
										const e = require("ace-builds/src-noconflict/ext-searchbox");
										e.Search(aceEditorRef.current.editor, true);
									}
								}}>
									<span>Ersetzen</span>
									<div>
										<kbd>CTRL</kbd>+
										<kbd>Option</kbd>+
										<kbd>F</kbd>
									</div>
								</li>
								<li onClick={() => {
									aceEditorRef.current.editor.removeLines();
								}}>
									<span>Zeile löschen</span>
									<div>
										<kbd>CTRL</kbd>+
										<kbd>D</kbd>
									</div>
								</li>
								<li>
									<span className="text-muted">Zeile bewegen</span>
									<div>
										<kbd>ALT</kbd>+
										<kbd>↑ / ↓</kbd>
									</div>
								</li>
								<li onClick={() => {
									aceEditorRef.current.editor.indent();
								}}>
									<span>Einrücken</span>
									<div>
										<kbd>TAB</kbd>
									</div>
								</li>
								<li onClick={() => {
									aceEditorRef.current.editor.blockOutdent();
								}}>
									<span>Ausrücken</span>
									<div>
										<kbd>Shift</kbd>+
										<kbd>TAB</kbd>
									</div>
								</li>
								<li onClick={() => {
									aceEditorRef.current.editor.toggleCommentLines();
								}}>
									<span>Ein - / Auskommentieren</span>
									<div>
										<kbd>CTRL</kbd>+
										<kbd>/</kbd>
									</div>
								</li>
							</ul>
						</li>
					</ul>
					<div className="code-editor-menu-quick-actions">
						<div className="centered-svg-container" onClick={() => undo()}>
							<ReplyIcon className={!canUndo ? "disabled" : ""} />
						</div>
						<div className="centered-svg-container" onClick={() => redo()}>
							<ReplyIcon className={!canRedo ? "disabled flip-octicon" : "flip-octicon"} />
						</div>
						<div className="centered-svg-container" onClick={() => download()}>
							<DownloadIcon />
						</div>
						<div className="centered-svg-container" onClick={() => setIsInFullScreen(!isInFullscreen)}>
							{
								!isInFullscreen ? <ScreenFullIcon /> : <ScreenNormalIcon />
							}
						</div>
					</div>
					<button className="noselect btn btn-success"><PlayIcon className="mr-2" />Ausführen</button>
				</div>

				<AceEditor
					onChange={onCodeChange}
					ref={aceEditorRef}
					width="100%"
					height={isInFullscreen ? "90%" : "600px"}
					mode="python"
					theme="monokai"
					value={props?.code}
					placeholder="Schreibe hier deinen Python code"
					showPrintMargin={true}
					showGutter={true}
					highlightActiveLine={true}
					fontSize={16}
					setOptions={{
						useWorker: false,
						enableBasicAutocompletion: true,
						enableLiveAutocompletion: true,
						enableSnippets: true,
						showLineNumbers: true,
						tabSize: 2
					}}
					commands={[{
						name: 'saveCommand',
						bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
						exec: () => {
							console.log("key binding CTRL + s used")
						}
					}]}
				/>
			</div>
		</>
	)
}
